module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"encryptionMessage":"Data preview is not available due to encryption."}}')
  delete Component.options._Ctor
}
